<template>

    <div class="ui-grid">
        <slot></slot>
    </div>

</template>

<script lang="ts">

import { Component, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-grid'
})
export default class Grid extends Vue {}

export type GridComp = InstanceType<typeof Grid>
export type GridProps = ComponentProps<GridComp>
export const gridCompMixin = createComponentMixin(Grid)

</script>
<style src="../../../scss/component/ui/Grid.scss" lang="scss"></style>